import { UserPreference, userPreferenceSchema } from '@repo/shared/domain';
import { guardedClient as clientRequest } from '@repo/shared/helpers';

export async function getUserPreferences(): Promise<UserPreference> {
	const response = await clientRequest.get(`/api/user-preferences`, { schema: userPreferenceSchema });
	return response.body;
}
